import React from "react";
import SearchFormView from "./SearchFormView";
import SearchResultsView from "./SearchResultsView";

export default function BrowseView({
  query,
  setQuery,
  onSearch,
  results,
  totalCount,
  loading,
  hasNextPage,
  onLoadNextPage,
  onAddToFavorites,
  isFavorite,
}) {
  return (
    <div className="browse-view">
      <SearchFormView
        query={query} 
        setQuery={setQuery} 
        onSearch={onSearch} 
        loading={loading} 
      />
      {totalCount > 0 && ( //only show result counter if there are results
        <p className="results-count">{`${totalCount} results found`}</p>
      )}
      <SearchResultsView
        results={results} 
        query={query} //needed for no results found conditional
        onAddToFavorites={onAddToFavorites}
        isFavorite={isFavorite}
      />
      {hasNextPage && (
        <button
          className="load-more-button"
          onClick={onLoadNextPage} 
          disabled={loading}
        >
          {loading ? "Loading..." : "Load More"}
        </button>
      )}
    </div>
  );
}